export default __webpack_public_path__ + "static/media/01_photo.4cfaede4.jpeg";